import MiscContent from '../Page/MiscContent/MiscContent'
import React from 'react'
import StringConstants from '../../../../constants/StringConstants'
import setUpIcon from '../../../../assets/images/error 3.svg'
import vigilLogo from '../../../../assets/icons/Vigil Logo Greyed out.svg'

const AccessDeniedPage = () => {
  localStorage.setItem(
    StringConstants.LOCAL_STORAGE.CURRENT_PAGE_DETAILS,
    JSON.stringify({
      'organization-id': '',
      'project-id': '',
      'environment-id': ''
    })
  )
  return (
    <div className='flex flex-col min-h-screen'>
      <MiscContent
        imgSrc={setUpIcon}
        text='Access Denied!'
        buttonLabel='Return to Homepage'
        vigilLogoSrc={vigilLogo}
      />
    </div>
  )
}

export default AccessDeniedPage
